import React, { PureComponent } from "react";
import { Link } from "react-router";
import Logo from "./assets/LandingPageLogo.png";
import { postRequest } from "../api/ApiService";
import {
  logError,
  validateEmail,
  ucfirst,
  detectMobile,
  getLogoStyle
} from "../services/utils";

const RESET_PASSWORD_URL = `${process.env.REACT_APP_API_URL}account/password_reset/`;

const ERROR_MESSAGE =
  "You do not have an email on file, please have Market Games admin add an email for you.";
const SUCCESS_MESSAGE =
  "We have sent a reset password link to your email on file. Please check your email.";

class ResetPasswordPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      validEmail: true,
      result: "",
      resultStatus: ""
    };

    this.isMobile = detectMobile();
  }

  handleInputChange = e => {
    this.setState({
      [e.target.id]: e.target.value,
      result: "",
      resultStatus: ""
    });
  };

  isValidEmail = () => {
    const { email } = this.state;
    const validEmail = validateEmail(email);

    this.setState({
      validEmail
    });
  };

  handleSubmit = () => {
    this.isValidEmail();

    const { email, validEmail } = this.state;

    if (validEmail === false) {
      return;
    }

    postRequest(RESET_PASSWORD_URL)
      .send({
        email
      })
      .then(response => {
        const message =
          response.body === "reset email sent"
            ? SUCCESS_MESSAGE
            : ucfirst(response.body);

        this.setState({
          result: message,
          resultStatus: "success"
        });
      })
      .catch(err => {
        if (err.response && err.response.statusCode === 404) {
          const message =
            err.response.body === "user not found"
              ? ERROR_MESSAGE
              : ucfirst(err.response.body);

          this.setState({
            result: message,
            resultStatus: "danger"
          });
        } else {
          logError(err, "ResetPasswordPage", "handleSubmit");
        }
      });
  };

  onSubmit = e => {
    e.preventDefault();
  };

  render() {
    const { email, validEmail, result, resultStatus } = this.state;
    const logoStyle = getLogoStyle(this.isMobile);
    const formGroupClass =
      validEmail === true
        ? "form-group"
        : "form-group has-error reset-password-error";
    const alertClass = `alert alert-${resultStatus}`;
    const formClass = this.isMobile ? "mg-top-5vh" : "mg-top-10vh";
    const buttonStyle = this.isMobile
      ? {
          paddingTop: "20px"
        }
      : {};

    return (
      <div className="container-fluid bg-color-blue height-100vh">
        <div className="text-center mg-top-15vh">
          <Link to="/welcome">
            <img src={Logo} style={logoStyle} alt="Logo" />
          </Link>
        </div>
        <div className={formClass}>
          {result !== "" && resultStatus !== "" && (
            <div className="row text-center">
              <div className="col-md-4 col-md-offset-4 col-xs-12">
                <div className={alertClass}>{result}</div>
              </div>
            </div>
          )}
          <form
            className="form-signin form-horizontal"
            onSubmit={this.onSubmit}
          >
            <div className={formGroupClass}>
              <label
                htmlFor="email"
                className="control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
              >
                E-mail
              </label>
              <div className="col-md-3 col-xs-12">
                <input
                  id="email"
                  type="text"
                  value={email}
                  onChange={this.handleInputChange}
                  onBlur={this.isValidEmail}
                  className="form-control border-radius-none"
                  placeholder="E-mail"
                  required={true}
                  autoFocus={!this.isMobile}
                />
                {validEmail === false && (
                  <span className="help-block">Email is not valid</span>
                )}
              </div>
            </div>
            <div className="row mg-top-3vh" style={buttonStyle}>
              <div className="col-md-4 col-md-offset-4 col-xs-12">
                <button
                  type="submit"
                  onClick={this.handleSubmit}
                  className="btn login-btn btn-lg btn-block"
                >
                  Reset password
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default ResetPasswordPage;



// WEBPACK FOOTER //
// ./src/containers/reset-password-page.js